import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=841eee1e&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=841eee1e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports